<template>
    <div class="context-right-side">
        <LocationList/>
    </div>
</template>

<script>
  import LocationList from "./LocationList";
  export default {
    name: "ContentRightSide",
      components: {LocationList}
  }
</script>

<style scoped>
    .context-right-side {
        /*position: relative;*/
        max-height: 100%;
        max-width: 100%;
        padding: 0;
        margin: 0;
        outline-offset: -2px;
        overflow-x: hidden;
        overflow-y: hidden;
        scrollbar-width: thin;
    }
</style>